import React from "react";
import SignUpForm from "./SignUpForm"

const Signup = ()=>{

    return (
        <SignUpForm />
    )
}
export default Signup;